module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_android_03-900-d45a4f7bd220c7dc602b9e7e06f9fa93.png";